const getters = {
  auth: (state) => {
    let root = state.contexts[state.context] || {}
    let {shops, ...rest} = root
    let shop = (shops||{})[state.context] || {}
    return { ...rest,
      context: state.context,
      name: rest.username || rest.email,
      login: state.login,
      stripe: shop.stripe || {},
      roles: shop.roles || [],
      isEditor: (shop.roles||[]).includes('editor'),
      set: !!rest.username
        && !!rest.userID
        && !!rest.token
    }
  }
}

export default getters